const hasIdentityValue = value =>
  value !== undefined && value !== null && String(value).trim() !== "";

export const resolveDataGridRowId = (row, primaryKey, fallbackId) => {
  const candidates = [
    primaryKey ? row?.[primaryKey] : undefined,
    row?.sDocNumber,
    row?.sControlNumber,
    row?.id
  ];
  const identity = candidates.find(hasIdentityValue);

  return hasIdentityValue(identity) ? String(identity) : fallbackId;
};

export const assignStableDataGridRowIds = (
  records = [],
  primaryKey,
  fallbackScope = "page"
) => records.map((record, index) => ({
  ...record,
  id: resolveDataGridRowId(record, primaryKey, `__${fallbackScope}_${index}`)
}));

export const mergeDataGridPageSelection = (
  previouslySelectedRows = [],
  currentPageRows = [],
  currentSelectionModel = []
) => {
  const pageIds = new Set(currentPageRows.map(row => String(row.id)));
  const selectedIds = new Set(currentSelectionModel.map(id => String(id)));
  const retainedRows = previouslySelectedRows.filter(
    row => !pageIds.has(String(row.id))
  );
  const selectedPageRows = currentPageRows.filter(
    row => selectedIds.has(String(row.id))
  );
  const selectedRowsById = new Map();

  [...retainedRows, ...selectedPageRows].forEach(row => {
    selectedRowsById.set(String(row.id), row);
  });

  return Array.from(selectedRowsById.values());
};

export const retainSelectedVerificationStatuses = (
  verificationStatuses = [],
  selectedRows = [],
  primaryKey
) => {
  const selectedRecordIds = new Set(selectedRows
    .map(row =>
      (primaryKey ? row?.[primaryKey] : undefined) ?? row?.sDocNumber ?? row?.id
    )
    .filter(hasIdentityValue)
    .map(value => String(value)));

  return verificationStatuses.filter(status =>
    selectedRecordIds.has(String(status?.id))
  );
};
